import React, { useRef,useState  } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import TKLogo from "../../TKLogo/TKLogo";
import TKIcon from "../../TKIcon/TKIcon";
import { useDispatch, useSelector } from "react-redux";
import { tkCHSNewPasswordRequest } from "../../../store/actions/cardHolders";

const TKNewPasswordForm = ({ setShowModal }) => {
    
  const [error, setErrors] = useState('');
  const [newPassError, setNewPasswordError] = useState('');

  const {tckn} = useSelector(state => state.cardHolders);
  const {vkn} = useSelector(state => state.memberWorkplaces);




  const dispatch = useDispatch();

  const validationCodeRef = useRef();
  const newPasswordRef = useRef();
  const newPasswordRetypeRef = useRef();


  function validate(e) {
    e.preventDefault();
    const validation_code = validationCodeRef?.current?.value;
    const password = newPasswordRef?.current?.value;
    if (checkValidation()){
    dispatch(tkCHSNewPasswordRequest({
        data :{

          validation_code,
          password,
          ...(tckn ? {tckn} : {}),
          ...(vkn ? {vkn} : {})
        } ,
        handleNewPasswordModal : show => setShowModal(show)
      }));
    }
  }

  const checkValidation = () => {
    
    setErrors('')
    setNewPasswordError('')

    const length = validationCodeRef?.current?.value.length
    const newpassword = newPasswordRef?.current?.value
    const newpasswordretype = newPasswordRetypeRef?.current?.value

    const newpasswordlength = newpassword?.length;
    const newpasswordretypelength = newpasswordretype?.length;

    if (length != 4) {
        setErrors('Doğrulama kodu dört haneli olmalı')
        return false;
    }
    if (newpasswordlength < 6 || newpasswordretypelength <6) {
       setNewPasswordError('Şifreniz en az 6 haneli olmalı')
       return false;
    }
    if (newpassword != newpasswordretype) {
       setNewPasswordError('Şifreler eşleşmiyor')
       return false;
    }
    if (length === 4 &&  newpassword == newpasswordretype) {
      return true;
    }


  }

  return (
    <>
       <Card className="border-0 tk-login-form">
        <Card.Header className="d-flex bg-primary p-3 justify-content-center align-items-center">
          <Card.Title className="m-0 d-flex justify-content-center align-items-center">
            <div>
              <TKLogo size={150} />
            </div>
            <span>
              <small>
                <i className="text-white">| Yeni Şifre Oluştur</i>
              </small>
            </span>
            <div className="position-absolute" style={{ right: "10px", top: "10px", transform: "rotate(45deg)" }} onClick={() => setShowModal(false)}>
              <TKIcon name="plus" color="white" size="15" />
            </div>
          </Card.Title>
        </Card.Header>

        <Card.Body className="p-5">
        <Form>
          <Form.Group className="mb-2" controlId="formBasicName">
              <Form.Label> Doğrulama kodunuzu giriniz * </Form.Label>
              <Form.Control
               size="xs"
               maxLength="4"
               ref={validationCodeRef}
                 />
              <Form.Text className="text-danger">{error}</Form.Text>
            </Form.Group>
            <Form.Group className="mb-2" controlId="formBasicName">
              <Form.Label> Yeni şifrenizi giriniz * </Form.Label>
              <Form.Control
               size="xs"
               type="password"
               ref={newPasswordRef}
                 />
              <Form.Text className="text-danger">{newPassError}</Form.Text>
            </Form.Group>
            <Form.Group className="mb-2" controlId="formBasicName">
              <Form.Label> Yeni şifrenizi tekrar giriniz * </Form.Label>
              <Form.Control
               size="xs"
               type="password"
               ref={newPasswordRetypeRef}
                 />
              <Form.Text className="text-danger">{newPassError}</Form.Text>
            </Form.Group>
            <div className="d-flex w-100 justify-content-end">
            <Button className="mt-2" variant="primary" type="submit"  onClick={(e) => validate(e)}>
              Şifre Oluştur
            </Button>
            </div>
        </Form>

        </Card.Body>
      </Card>
    </>
  );
};

export default TKNewPasswordForm;

TKNewPasswordForm.defaultProps = {
  setShowModal: () => {},
};
